import { Chart as ChartJS } from 'chart.js'
import { defineComponent, h } from 'vue'
import _ from 'lodash'
import { registerChartComponents } from './chartSetup'
import { buildExternalTooltip } from './chartTooltip'

export default defineComponent({
  name: 'LineChart',
  props: {
    chartData: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      chart: null
    }
  },
  computed: {
    optionsWithCustomTooltip () {
      const optionsCopy = _.cloneDeep(this.options)
      if (!optionsCopy.plugins) optionsCopy.plugins = {}
      if (!optionsCopy.plugins.tooltip) {
        optionsCopy.plugins.tooltip = {
          enabled: false,
          external: buildExternalTooltip()
        }
      }
      return optionsCopy
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler () {
        this.renderChart()
      }
    },
    options: {
      deep: true,
      handler () {
        this.renderChart()
      }
    }
  },
  mounted () {
    registerChartComponents()
    this.renderChart()
  },
  beforeUnmount () {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    renderChart () {
      if (!this.$refs.canvas) return
      if (this.chart) {
        this.chart.destroy()
      }
      this.chart = new ChartJS(this.$refs.canvas, {
        type: 'line',
        data: this.chartData,
        options: this.optionsWithCustomTooltip
      })
    }
  },
  render () {
    return h('canvas', { ref: 'canvas' })
  }
})
